import React from "react";
import { toUrl } from "../../lib/config";
import MegaparkLogo from "../../assets/images/megapark.png";
import "../../assets/styles/doctor-hero.scss";

type DoctorHeroProps = {
  logoSrc?: string;
  logoAlt?: string;
  kicker?: string;               // "Hekimler"
  titleMain?: string;            // "Profesyonel Doktor"
  titleAccent?: string;          // "Ekibi"
  description?: string;          // açıklama
};

const DoctorHero: React.FC<DoctorHeroProps> = ({
  logoSrc = "/assets/markasi-logo.svg",
  logoAlt = "Markası Hospital",
  kicker = "Hekimler",
  titleMain = "Profesyonel Doktor",
  titleAccent = "Ekibi",
  description = "Hastanemizin profesyonel kadrosuyla bütün birimlerinde birçok hastalığın tedavi süreci profesyonelce ilerletilip en hızlı ve güvenli şekilde tedavi imkanı sunmaktadır."
}) => {
  const ImgWithFallback: React.FC<{ src?: string; alt?: string; className?: string }> = ({ src, alt, className }) => {
    const input = (src || "").trim();
    let abs = "";
    if (!input) {
      abs = "";
    } else if (/^https?:\/\//i.test(input)) {
      abs = input;
    } else if (input.startsWith('/api/')) {
      abs = toUrl(input);
    } else {
      // assume UUID
      abs = toUrl(`/api/media/${input}`);
    }
    const [current, setCurrent] = React.useState(abs);
    return (
      <img
        src={current || (MegaparkLogo as unknown as string)}
        alt={alt || ''}
        className={className}
        style={{ maxWidth: 300, width: '100%', height: 'auto', objectFit: 'contain', display: 'block' }}
        crossOrigin="anonymous"
        loading="eager"
        onError={(e) => {
          const cur = e.currentTarget.getAttribute('src') || '';
          const fallback = MegaparkLogo as unknown as string;
          if (cur !== fallback) e.currentTarget.src = fallback;
        }}
      />
    );
  };
  return (
    <section className="doctor-hero" aria-labelledby="doctor-hero-title">
      <div className="dh-container">
        <div className="dh-logo">
          <ImgWithFallback src={logoSrc} alt={logoAlt} />
        </div>

        <div className="dh-copy">
          <p className="dh-kicker">{kicker}</p>

          <h1 className="dh-title" id="doctor-hero-title">
            <span className="main">{titleMain}</span>
            <span className="accent"> {titleAccent}</span>
          </h1>

          <p className="dh-desc">{description}</p>
          <hr className="dh-divider" />
        </div>
      </div>
    </section>
  );
};

export default DoctorHero;
